var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPoliceHighlighted({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.039,
    height: 59.748,
    viewBox: "0 0 53.039 59.748",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29428",
    "data-name": "Group 29428",
    transform: "translate(-287.999 -502.165)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svgexport-7_20_",
    "data-name": "svgexport-7 (20)",
    transform: "translate(287.999 502.165)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48766",
    "data-name": "Path 48766",
    d: "M76.459,46.592a.961.961,0,1,1,.9-1.7,11.014,11.014,0,0,1,3.2,2.393,4.54,4.54,0,0,1,1.231,2.987c0,2.811-3.113,5.254-8.148,6.93a60.509,60.509,0,0,1-18.371,2.546A60.5,60.5,0,0,1,36.9,57.2c-5.035-1.676-8.148-4.119-8.148-6.93a4.544,4.544,0,0,1,1.231-2.987,11.015,11.015,0,0,1,3.2-2.393.961.961,0,1,1,.9,1.7,9.161,9.161,0,0,0-2.643,1.949,2.689,2.689,0,0,0-.757,1.73c0,1.89,2.609,3.7,6.824,5.108a58.6,58.6,0,0,0,17.769,2.44,58.606,58.606,0,0,0,17.77-2.44c4.216-1.4,6.823-3.217,6.823-5.107a2.687,2.687,0,0,0-.757-1.73,9.144,9.144,0,0,0-2.643-1.949ZM48.677,43.021a24.169,24.169,0,0,0-6.952,1.915c-1.483.729-2.35,1.52-2.35,2.284,0,1.09,1.634,2.179,4.274,3.058a38.326,38.326,0,0,0,11.618,1.592,38.324,38.324,0,0,0,11.618-1.592c2.641-.88,4.275-1.969,4.275-3.058,0-.764-.866-1.555-2.351-2.284a24.166,24.166,0,0,0-6.951-1.915,35.368,35.368,0,0,1-6.087,4.956.959.959,0,0,1-1.028-.012,35.482,35.482,0,0,1-6.067-4.944ZM55.267,8.5a10.049,10.049,0,1,1-7.107,2.943A10.049,10.049,0,0,1,55.267,8.5Zm5.744,4.306a8.122,8.122,0,1,0,2.379,5.743,8.122,8.122,0,0,0-2.379-5.743ZM49.977,41.6a34.97,34.97,0,0,0,5.29,4.425,35.047,35.047,0,0,0,5.29-4.423A46.03,46.03,0,0,0,71.012,25.761c2.178-5.913,2.527-12.143-.78-17.476a18.044,18.044,0,0,0-2.6-3.245,17.69,17.69,0,0,0-24.732,0,18.044,18.044,0,0,0-2.6,3.245c-3.307,5.333-2.958,11.563-.779,17.476A46.009,46.009,0,0,0,49.977,41.6Z",
    transform: "translate(-28.748 0)",
    fill: "#1a74e2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_284",
    "data-name": "Ellipse 284",
    cx: 15.884,
    cy: 15.884,
    r: 15.884,
    transform: "translate(10.685 1.444)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_29425",
    "data-name": "Group 29425",
    transform: "translate(4.852 -1.042)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50862",
    "data-name": "Path 50862",
    d: "M261.363,259.706l-1.81-1.273a3.153,3.153,0,0,0-1.212-1.547c-.815-.47-1.475.029-1.475,1.115a3.531,3.531,0,0,0,1.475,2.817.928.928,0,0,0,1,.056Zm0,0",
    transform: "translate(52.837 268.438)",
    fill: "#23292e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50850",
    "data-name": "Path 50850",
    d: "M21.115,8.032,17.808,5.671l-.369-.809A7.95,7.95,0,0,0,14.2,1.289L13.112.679A4.314,4.314,0,0,0,9.686.28L8.234.722,7.058.049A.364.364,0,0,0,6.7.044h0L.2,3.862a.366.366,0,0,0-.2.326V5.2A2.03,2.03,0,0,0,1.016,6.956l13.894,8.025a3.046,3.046,0,0,0,3.085.012l3.574-2.081a1.2,1.2,0,0,0,.594-1.033V10.068a2.5,2.5,0,0,0-1.048-2.035Zm0,0",
    transform: "translate(298.585 514.033)",
    fill: "#2e373d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50851",
    "data-name": "Path 50851",
    d: "M41.4,6.146a4.314,4.314,0,0,1,3.426.4l1.092.61a7.95,7.95,0,0,1,3.235,3.573l.369.809,6.5-3.818-.369-.809A7.951,7.951,0,0,0,52.42,3.337l-1.092-.61a4.314,4.314,0,0,0-3.426-.4L46.45,2.77l-6.5,3.818Zm0,0",
    transform: "translate(260.37 511.985)",
    fill: "#ededed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50852",
    "data-name": "Path 50852",
    d: "M21.634,121.891l-1.81-1.273a3.152,3.152,0,0,0-1.212-1.547c-.814-.47-1.474.029-1.474,1.115A3.531,3.531,0,0,0,18.612,123a.928.928,0,0,0,1,.056Zm0,0",
    transform: "translate(282.189 400.287)",
    fill: "#23292e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50853",
    "data-name": "Path 50853",
    d: "M4.881,3.867l1.176.673,6.5-3.818L11.385.049a.364.364,0,0,0-.354-.005h0L4.523,3.862a.366.366,0,0,1,.358,0Zm20.787,7.279.093-.429a1.446,1.446,0,0,1,.71-.957c0,.013,0,.026,0,.038a2.5,2.5,0,0,0-1.032-1.766L22.136,5.671l-6.5,3.818,3.307,2.362a2.487,2.487,0,0,1,.418.377h0l.925.519a1.047,1.047,0,0,0,1.036-.006.517.517,0,0,1,.517,0l.536.309Zm0,0",
    transform: "translate(294.259 514.033)",
    fill: "#525e65"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50854",
    "data-name": "Path 50854",
    d: "M49.15,95.111a7.95,7.95,0,0,0-3.235-3.573l-1.092-.61a4.315,4.315,0,0,0-3.426-.4l-1.453.442a3.074,3.074,0,0,0,.628,1.861l1.8,2.367,7.145,4.12v-3.4Zm0,0",
    transform: "translate(260.37 427.603)",
    fill: "#82a5b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50855",
    "data-name": "Path 50855",
    d: "M.553,88.233A.37.37,0,0,0,0,88.554v1.01a2.029,2.029,0,0,0,1.016,1.758l3.142,1.812-1.8-2.367a3.074,3.074,0,0,1-.628-1.861Zm14,9.013.348.2a3.091,3.091,0,0,0,.529.242l-.4-1.095a2.489,2.489,0,0,0-.418-.377L11.3,93.855v3.4l3.248,1.873a.7.7,0,0,1-.261-.459l-.15-1.148a.275.275,0,0,1,.41-.274Zm0,0",
    transform: "translate(298.585 429.667)",
    fill: "#23292e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50863",
    "data-name": "Path 50863",
    d: "M259.816,259.7c0,1.086-.66,1.585-1.474,1.115A3.531,3.531,0,0,1,256.867,258c0-1.086.66-1.585,1.475-1.115A3.532,3.532,0,0,1,259.816,259.7Zm0,0",
    transform: "translate(52.837 268.438)",
    fill: "#2e373d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50864",
    "data-name": "Path 50864",
    d: "M275.634,283.346c0,.534-.324.779-.725.548a1.736,1.736,0,0,1-.725-1.385c0-.534.325-.779.725-.548A1.737,1.737,0,0,1,275.634,283.346Zm0,0",
    transform: "translate(36.27 244.362)",
    fill: "#cecece"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50865",
    "data-name": "Path 50865",
    d: "M282.634,293.813c0,.29-.176.423-.393.3a.942.942,0,0,1-.393-.751c0-.289.176-.423.393-.3a.942.942,0,0,1,.393.751Zm0,0",
    transform: "translate(28.938 233.703)",
    fill: "#627681"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50856",
    "data-name": "Path 50856",
    d: "M20.086,121.888c0,1.086-.66,1.585-1.475,1.115a3.531,3.531,0,0,1-1.474-2.817c0-1.086.66-1.585,1.474-1.115A3.531,3.531,0,0,1,20.086,121.888Zm0,0",
    transform: "translate(282.189 400.287)",
    fill: "#2e373d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50857",
    "data-name": "Path 50857",
    d: "M35.9,145.532c0,.534-.325.779-.725.548a1.736,1.736,0,0,1-.725-1.385c0-.534.325-.779.725-.548a1.736,1.736,0,0,1,.725,1.385Zm0,0",
    transform: "translate(265.624 376.21)",
    fill: "#cecece"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50858",
    "data-name": "Path 50858",
    d: "M42.9,156c0,.29-.176.423-.393.3a.942.942,0,0,1-.393-.751c0-.289.176-.423.393-.3A.942.942,0,0,1,42.9,156Zm0,0",
    transform: "translate(258.291 365.554)",
    fill: "#627681"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50866",
    "data-name": "Path 50866",
    d: "M348.606,283.728a3.093,3.093,0,0,0,1.546-.414l.053-.031-.536-.31a.517.517,0,0,0-.517,0,1.047,1.047,0,0,1-1.036.006l-.925-.519.4,1.1A3.089,3.089,0,0,0,348.606,283.728Zm0,0",
    transform: "translate(-33.577 243.8)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50867",
    "data-name": "Path 50867",
    d: "M239.287,81.9l-1.052-1.941a.864.864,0,0,1,.328-1.16l4.53-2.615a.789.789,0,0,1,1.077.288l1.131,1.956Zm0,0",
    transform: "translate(70.764 441.245)",
    fill: "#304e75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50859",
    "data-name": "Path 50859",
    d: "M156.6,119.448l3.8,1.966-.6-1.117a6.35,6.35,0,0,0-2.413-2.483l-.429-.247c-.117-.068-.238-.129-.359-.186Zm0,0",
    transform: "translate(148.766 401.736)",
    fill: "#243b58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50868",
    "data-name": "Path 50868",
    d: "M328.619,76.2a.78.78,0,0,0-.331.1l-1.108.64,2.749,1.421-.6-1.117a6.363,6.363,0,0,0-.708-1.044Zm0,0",
    transform: "translate(-14.432 441.134)",
    fill: "#59718b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50860",
    "data-name": "Path 50860",
    d: "M63.908,106.493a5,5,0,0,0-3.088-.033l-.535.168,3.623,1.873Zm0,0",
    transform: "translate(240.91 412.4)",
    fill: "#243b58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50869",
    "data-name": "Path 50869",
    d: "M493,226.839l.822-.454v-.625a2.51,2.51,0,0,0-.019-.308,1.447,1.447,0,0,0-.71.957Zm0,0",
    transform: "translate(-173.074 298.341)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50861",
    "data-name": "Path 50861",
    d: "M99.422,134.562a.629.629,0,0,1,.246.272.816.816,0,0,1,.085.365v.271a.311.311,0,0,1-.1.26.2.2,0,0,1-.234,0l-.122-.07v.7l-.211-.122v-1.867Zm.126.523a.3.3,0,0,0-.033-.137.225.225,0,0,0-.088-.1l-.127-.074v.6l.127.074a.072.072,0,0,0,.086,0,.113.113,0,0,0,.035-.094v-.273Zm.684-.079a.636.636,0,0,1,.237.268.8.8,0,0,1,.1.372v1.019a.305.305,0,0,1-.1.26.2.2,0,0,1-.237-.006.634.634,0,0,1-.237-.268.8.8,0,0,1-.1-.372V135.26a.305.305,0,0,1,.1-.26A.2.2,0,0,1,100.232,135.006Zm.115.508a.288.288,0,0,0-.035-.134.23.23,0,0,0-.086-.1.074.074,0,0,0-.086,0,.109.109,0,0,0-.036.094V136.4a.286.286,0,0,0,.036.135.233.233,0,0,0,.086.1.073.073,0,0,0,.086,0,.11.11,0,0,0,.035-.094Zm.982,2.017-.575-.332v-1.867l.211.122v1.587l.364.21Zm.356.206-.211-.122v-1.867l.211.122Zm.522.325a.636.636,0,0,1-.237-.268.8.8,0,0,1-.1-.372V136.4a.305.305,0,0,1,.1-.26.2.2,0,0,1,.237.006.633.633,0,0,1,.237.268.8.8,0,0,1,.1.372V137l-.219-.126v-.219a.292.292,0,0,0-.036-.135.231.231,0,0,0-.086-.1.072.072,0,0,0-.086,0,.113.113,0,0,0-.035.094v1.022a.289.289,0,0,0,.035.134.23.23,0,0,0,.086.1.074.074,0,0,0,.086,0,.109.109,0,0,0,.036-.093v-.258l.219.126v.261a.3.3,0,0,1-.1.259A.2.2,0,0,1,102.208,138.061Zm.507.269v-1.869l.6.347v.283l-.39-.225v.51l.285.164v.283l-.285-.165v.51l.39.225v.283Zm3.762-1.1,5.74,3.224,4.016-2.286L112.4,133.75Zm0,0",
    transform: "translate(203.785 386.073)",
    fill: "#2e373d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50870",
    "data-name": "Path 50870",
    d: "M223.425,38.242l-1.339-.773-3.762,2.172v.432l1.328.767,3.772-2.178Zm0,0",
    transform: "translate(89.713 478.187)",
    fill: "#cecece"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50871",
    "data-name": "Path 50871",
    d: "M218.324,87.637v.432l1.328.767v-.42Zm0,0",
    transform: "translate(89.713 430.19)",
    fill: "#525e65"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50872",
    "data-name": "Path 50872",
    d: "M249.008,57.51l3.772-2.178v.42l-3.772,2.178Zm0,0",
    transform: "translate(60.356 461.097)",
    fill: "#627681"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50873",
    "data-name": "Path 50873",
    d: "M234.522,23.732l-.067-.039a.289.289,0,0,0-.29-.026l0,0-1.6.925-1.427.824a.386.386,0,0,0-.169.37v.511l.966.558,3.04-1.749v-.511A1.077,1.077,0,0,0,234.522,23.732Zm0,0",
    transform: "translate(77.618 491.418)",
    fill: "#243b58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50874",
    "data-name": "Path 50874",
    d: "M269.781,23.732l-.067-.039a.289.289,0,0,0-.29-.026l0,0-1.6.925a.47.47,0,0,1,.337,0l.067.039a1.077,1.077,0,0,1,.45.859V26l1.557-.9v-.511A1.077,1.077,0,0,0,269.781,23.732Zm0,0",
    transform: "translate(42.358 491.418)",
    fill: "#e33400"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50875",
    "data-name": "Path 50875",
    d: "M236.694,44.43l-.067-.039a.271.271,0,0,0-.333.006l0-.006-1.427.824a.293.293,0,0,1,.281.03l.067.039a1.077,1.077,0,0,1,.45.859v.511l1.483-.854v-.511A1.077,1.077,0,0,0,236.694,44.43Zm0,0",
    transform: "translate(73.889 471.616)",
    fill: "#304e75"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoliceHighlighted);
export default __webpack_public_path__ + "static/media/policeHighlighted.98ed5f81a852488813e5bacd0f3697ee.svg";
export { ForwardRef as ReactComponent };